import React from 'react';
import { useLocation } from 'react-router-dom';
import Seo from '../components/Seo/Seo';

/**
 * SEO for the search results page.
 *
 * The bare /guest-search-results page is indexable, but every filter/sort
 * combination (?keyword=&checkin=&price_max=...) would otherwise create an
 * unbounded number of near-duplicate URLs that waste crawl budget and dilute
 * ranking signals. Parameterised views are marked noindex; their canonical
 * already points at the clean base URL via Seo's param-stripping.
 */
const SearchSeo: React.FC = () => {
  const location = useLocation();
  const hasParams = location.search.length > 1;

  return (
    <Seo
      title="Find a Stay"
      description="Search verified PG beds with 3 meals a day across Bangalore, Chennai, Delhi and more. All-inclusive short stays at budget nightly rates."
      path="/guest-search-results"
      noindex={hasParams}
    />
  );
};

export default SearchSeo;
